// import { Calendar } from '@fullcalendar/core';
import FullCalendar, { EventApi } from '@fullcalendar/react'; // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid';
import pt from '@fullcalendar/core/locales/pt';
import React from 'react';
import { Container } from './styles';

type EventsProps = {
  title: string;
  start: Date;
  end: Date;
};
interface CalendarProps {
  events: EventsProps[];
  handleChangeDate: (start: Date, end: Date) => void;
  handleEventClick: (event: EventApi) => void;
}

export interface Event extends EventsProps {
  id?: number;
  title: string;
  start: Date;
  end: Date;
  allDay?: boolean;
  backgroundColor?: string;
  borderColor?: string;
}

const Calendar: React.FC<CalendarProps> = ({
  events,
  handleChangeDate,
  handleEventClick,
}: CalendarProps) => {
  return (
    <Container className="calendar-container">
      <FullCalendar
        plugins={[dayGridPlugin]}
        events={events}
        initialView="dayGridMonth"
        datesSet={dateInfo => {
          handleChangeDate(dateInfo.start, dateInfo.end);
        }}
        eventClick={eventInfo => handleEventClick(eventInfo.event)}
        locale={pt}
        firstDay={0} // Para o calendário começar no domingo
        dayMaxEventRows
        views={{ timeGrid: { dayMaxEventRows: 16 } }}
        headerToolbar={{ right: 'today prevYear,prev,next,nextYear' }}
      />
    </Container>
  );
};

export default Calendar;

// export default class Calendar extends React.Component {
//   render() {
//     return <Calendar plugins={[dayGridPlugin]} initialView="dayGridMonth" />;
//   }
// }
// document.addEventListener('DOMContentLoaded', function() {
//   const calendarEl: HTMLElement = document.getElementById('calendar')!;

//   const calendar = new Calendar(calendarEl, {
//     plugins: [dayGridPlugin],
//     // options here
//   });

//   calendar.render();
// });

// // import { Calendar } from '@fullcalendar/core';
// import FullCalendar from '@fullcalendar/react'; // must go before plugins
// import dayGridPlugin from '@fullcalendar/daygrid';

// export default class FullCalendar extends React.Component {
//   render() {
//     return <Calendar plugins={[dayGridPlugin]} initialView="dayGridMonth" />;
//   }
// }
// // document.addEventListener('DOMContentLoaded', function() {
// //   const calendarEl: HTMLElement = document.getElementById('calendar')!;

// //   const calendar = new Calendar(calendarEl, {
// //     plugins: [dayGridPlugin],
// //     // options here
// //   });

// //   calendar.render();
// // });
